import { render, staticRenderFns } from "./teacher.vue?vue&type=template&id=266c8ced&scoped=true&"
import script from "./teacher.vue?vue&type=script&lang=ts&"
export * from "./teacher.vue?vue&type=script&lang=ts&"
import style0 from "./teacher.vue?vue&type=style&index=0&id=266c8ced&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266c8ced",
  null
  
)

export default component.exports